export function readerResultToString(result: string | ArrayBuffer | null) {
	if (result instanceof ArrayBuffer) {
		return String.fromCharCode(...new Uint16Array(result));
	} else if (typeof result === "string") {
		return result;
	}
	return "";
}
